// Obscured admin route path for security
export const ADMIN_BASE_PATH = "/sys-mgmt-x7k2p";
